import { Component, Input, OnInit } from '@angular/core';
import { PopoverService } from 'src/app/services/popover.service';

@Component({
  selector: 'app-information-popup',
  templateUrl: './information-popup.component.html',
  styleUrls: ['./information-popup.component.scss'],
})
export class InformationPopupComponent implements OnInit {

  @Input('infoContent') infoContent: string;
  @Input('titleContent') titleContent: string;
  @Input('displayInPopover') displayInPopover: boolean;
  public displayInfo: boolean = false;
  displayIcon: boolean = true;

  constructor(
    public popoverService: PopoverService
  ) {
    this.displayInfo = false;
  }

  ngOnInit() {
  }


  toggleDisplay() {
    if (this.displayInfo) {
      this.displayInfo = false;
    }
    else {
      this.displayInfo = true;
    }
  }

  setIconStyle() {
    let styles = {
      'color': this.displayInfo ? '#7f57ba' : this.displayIcon ? '#0033cc' : '#F5F6F9',
      'font-size': '28px',
      'cursor': 'pointer',
      'margin': '2px'
    }
    return styles;
  }

  getBackgroundColor() {
    return this.displayInfo ? 'infobackground' : 'transparent'
  }

  setTextAreaStyle() {
    let styles = {
      'background-color': this.displayInfo ? '#EDE0FF' : 'transparent',
      'padding': '5px',
      'border': this.displayInfo ? '3px solid #7f57ba' : '0'
    }

    return styles;
  }

  async displayInformationPopover(event) {
    this.displayIcon = false;
    var popover = await this.popoverService.getInfoPopover(event, this.titleContent, this.infoContent);
    popover.onWillDismiss().then(x => {
      this.displayIcon = true;
    })

    await popover.present();

    var el = document.getElementsByClassName("information-popover")[0] as HTMLElement;
    if (el != null) {
      var wrapper = el.getElementsByClassName("popover-wrapper")[0] as HTMLElement;
      if (wrapper != null) {
        var content = wrapper.getElementsByClassName("popover-content")[0] as HTMLElement;
        if (content != null) {
          var top = parseInt(content.style.top);
          content.style.top = (top - 60).toString() + "px";
        }
      }
    }
  }

}
